module.exports = __webpack_public_path__ + "media/images/riders/STEPHANE_TEMPIER-5672f5d3e10ef80025fb4ca67cad0319.png";